module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_19.8c356435.pdf";